import { userManager } from './user.es.js';

const accessTokenInterceptor = (request) => {
  if (typeof window === "undefined")
    return;
  const accessToken = userManager.getAccessToken();
  if (accessToken) {
    request.headers.set("Authorization", `Bearer ${accessToken}`);
  }
};
const getAccessToken = () => userManager.getAccessToken();

export { accessTokenInterceptor, getAccessToken };
